import React, { useEffect, useState } from 'react';
import '../css/AnimatedText.css';

const AnimatedText = ({ text, animate }) => {
  const [animating, setAnimating] = useState([]);

  useEffect(() => {
    if (!animate) return;
  
    const timeouts = [];
  
    const chars = text.split('');
    chars.forEach((_, i) => {
      const delay = Math.random() * 1000;
  
      timeouts.push(setTimeout(() => {
        setAnimating(prev => {
          const newState = [...prev];
          newState[i] = 'up';
          return newState;
        });
  
        timeouts.push(setTimeout(() => {
          setAnimating(prev => {
            const newState = [...prev];
            newState[i] = 'down';
            return newState;
          });
        }, 500));
      }, delay));
    });
  
    return () => timeouts.forEach(clearTimeout);
  }, [text, animate]); // 🔁 include `animate` as a dependency
  

  let globalIndex = -1;

  return (
    <h1 className="animated-text-container">
      {text.split(' ').map((word, wordIdx) => (
        <span key={wordIdx} className="word-wrapper">
          {word.split('').map((char, i) => {
            globalIndex += 1;
            return (
              <span key={i} className="letter-mask">
                <span className={`letter ${animating[globalIndex] === 'up' ? 'fly-up' : animating[globalIndex] === 'down' ? 'fly-in' : ''}`}>
                  {char}
                </span>
              </span>
            );
          })}
          {/* Add a non-breaking space after each word (so words wrap properly) */}
          <span className="letter-mask">
            <span className="letter">&nbsp;</span>
          </span>
        </span>
      ))}
    </h1>
  );
};

export default AnimatedText;
